import linegraph from '../../../../../components/linegraph.vue'
import * as echarts from "echarts"
import iTable from "../../../../../components/Table.vue";
import IPagination from "../../../../../components/pagination.vue";
import { domainName } from "../../../../../utility/index"

export default {
    props: ["bindDriver"],
    data() {
        return {
            activeSelect: 'first',
            dayLoading: false,
            dayOption: {},
            orgId: '',
            isValue: true,
            isDisplay: true,
            driverNum: '',
            height: '500',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columnsAll: [
                {
                    prop: "driverNum",
                    label: this.$t('common.driverNum'),
                    align: "center",
                },
                {
                    prop: "name",
                    label: this.$t('common.driverName'),
                    align: "center",
                },
                {
                    prop: "orgName",
                    label: this.$t('common.orgName'),
                    align: "center",

                },
                {
                    prop: "moveTime",
                    label: this.$t('DriverAnalysis.moveTime'),
                    align: "center",

                },
                {
                    prop: "carryWeightTime",
                    label: this.$t('DriverAnalysis.carryWeightTime'),
                    align: "center",

                },
                {
                    prop: "freeTime",
                    label: this.$t('DriverAnalysis.freeTime'),
                    align: "center",

                },
                {
                    prop: "workTime",
                    label: this.$t('DriverAnalysis.workHour'),
                    align: "center",
                },
                {
                    prop: "moveLoadRate",
                    label: this.$t('DriverAnalysis.moveLoadRate'),
                    align: "center",

                }
            ],
            columnsOne: [
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                },
                {
                    prop: "terminalId",
                    label: this.$t('common.terminalId'),
                    align: "center",
                },
                {
                    prop: "driverNum",
                    label: this.$t('common.driverNum'),
                    align: "center",

                },
                {
                    prop: "driverName",
                    label: this.$t('common.driverName'),
                    align: "center",

                },
                {
                    prop: "orgName",
                    label: this.$t('common.orgName'),
                    align: "center",

                },
                {
                    prop: "startTime",
                    label: this.$t('DriverAnalysis.startTime'),
                    align: "center",
                    // render: (h, params) => {
                    //     return h('span', this.$formatTime(params.row.startTime))
                    // }
                },
                {
                    prop: "endTime",
                    label: this.$t('DriverAnalysis.endTime'),
                    align: "center",
                    // render: (h, params) => {
                    //     return h('span', this.$formatTime(params.row.endTime))
                    // }
                },
                {
                    prop: "moveDuration",
                    label: this.$t('DriverAnalysis.moveTime'),
                    align: "center",

                },
                {
                    prop: "carryDuration",
                    label: this.$t('DriverAnalysis.carryWeightTime'),
                    align: "center",

                },
                {
                    prop: "freeDuration",
                    label: this.$t('DriverAnalysis.freeTime'),
                    align: "center",
                },
                {
                    prop: "workTime",
                    label: this.$t('DriverAnalysis.workHour'),
                    align: "center",

                },
                {
                    prop: "moveLoadRate",
                    label: this.$t('DriverAnalysis.moveLoadRate'),
                    align: "center",

                },
            ],
            columns: [],
            operates: {
                width: 100,
                fixed: "right",
                list: [],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
        }
    },
    components: {
        linegraph,
        iTable,
        IPagination
    },
    methods: {
        initQuery(type) {
            this.type = type
            this.pageSize = 10
            this.currentPage = 1
            if (type == 'one') {
                this.columns = this.columnsOne
                this.getOneMonthOrderList()
            } else {
                this.columns = this.columnsAll
                this.getMonthOrderList()
            }
        },
        handleClick(event) {
            this.activeSelect = event.name
            if (this.activeSelect == 'first') {
                this.$nextTick(() => {
                    this.getDayUseRate()
                })
            } else {
                this.$nextTick(() => {
                    this.getDayUseRate()
                })

            }
        },
        getDayUseRate() {
            this.dayLoading = true
            let Data = []
            let dayUse = []
            let dataShadow = []
            let workTime = []
            let timeType = ''
            if (this.activeSelect == 'first') {
                timeType = '24'
            } else {
                timeType = '8'
            }
            let param = {
                orgId: Number(this.orgId),
                driverNum: this.driverNum,
                timeType: timeType,
                selectType: 0,
            }
            this.$store.dispatch("DriverAnalysis/GET_SELECTDRIVERDAILYUSRRATE", param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        res.data.data.map((item, index) => {
                            Data.push(item.date)
                            workTime.push({ time: item.workTime, date: item.date })
                            dataShadow.push(300)
                            if (item.dayUseRate == null) {
                                dayUse.push(0)
                            } else {
                                if (item.dayUseRate.indexOf('%') > -1) {
                                    let num = item.dayUseRate.split('%')[0]
                                    if (num > 300) {
                                        dayUse.push(300)
                                    } else {
                                        dayUse.push(Number(num))
                                    }
                                }
                            }
                        })
                        let maxNumber = Math.ceil(Math.max(...dayUse))
                        dataShadow.map((t, k) => {
                            dataShadow[k] = maxNumber
                        })
                        this.DayUseRate(Data, dayUse, workTime)
                    }
                }
                this.dayLoading = false
            }).catch(err => {
                this.dayLoading = false
            })
        },
        DayUseRate(Data, dayUse, workTime) {
            let option = {
                tooltip: {
                    show: true,
                    trigger: 'axis',
                    formatter: (item) => {
                        let workHour = ''
                        workTime.map((t, k) => {
                            if (item[0].name == t.date) {
                                workHour = t.time
                            }
                        })
                        return this.$t('common.date') + ':' + item[0].name + '<br/>' + this.$t('DriverAnalysis.workHour') + ':' + workHour + 'h' + '<br/>' + this.$t('BatteryAnalysis.rate') + ':' + item[0].value + '%'
                    },
                },
                legend: {
                    left: '10',
                    data: [this.$t('BatteryAnalysis.rate')],
                    itemWidth: 12,
                    itemHeight: 12,
                    textStyle: {
                        color: '#fff'
                    }
                },
                toolbox: {
                    right: '10',
                    feature: {
                        mark: { show: true, title: this.$t('common.mark') || 'Mark' },
                        dataView: { show: true, readOnly: false, backgroundColor: '#081831', textareaColor: '#081831', textColor: '#fff', title: this.$t('common.dataView') || 'Data View', lang: [this.$t('common.dataView') || 'Data View', this.$t('common.close') || 'Close', this.$t('common.refresh') || 'Refresh'] },
                        magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'], title: { line: this.$t('common.lineChart') || 'Line Chart', bar: this.$t('common.barChart') || 'Bar Chart', stack: this.$t('common.stackChart') || 'Stack Chart', tiled: this.$t('common.tiledChart') || 'Tiled Chart' } },
                        restore: { show: true, title: this.$t('common.restore') || 'Restore' },
                        saveAsImage: { name: this.$t('DriverAnalysis.dailyCarRate'), show: true, backgroundColor: '#081831', title: this.$t('common.saveAsImage') || 'Save as Image' }
                    },
                    iconStyle: {
                        color: '#fff'
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisTick: {
                        show: false
                    },
                    splitLine: { show: false },
                    axisLabel: {
                        textStyle: {
                            color: '#fff',

                        }
                    },
                    data: Data
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '2%',
                    containLabel: true
                },
                yAxis: [{
                    type: 'value',
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        formatter: '{value} %',
                        color: '#fff'
                    },
                    splitLine: {
                        show: true, lineStyle: {
                            color: ['rgba(173,177,195,.1)'],
                            type: 'dashed'
                        }
                    },
                    min: 0,
                }],
                series: [
                    {
                        name: this.$t('BatteryAnalysis.rate'),
                        data: dayUse,
                        type: 'bar',
                        barCategoryGap: '40%',
                        label: {
                            show: true,
                            position: 'top',
                            color: '#fff'
                        },
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: '#1e89f8' },
                                        { offset: 1, color: '#4fa3fb' },
                                    ]
                                )
                            },
                        }
                    },
                ]
            }
            this.dayOption = option
        },

        getMonthOrderList() {
            let param = {
                orgId: this.orgId,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                selectType: 0,
            };
            this.$store.dispatch('DriverAnalysis/GET_SELECTDRIVERUSRRATEPAGE', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        getOneMonthOrderList() {
            let param = {
                orgId: this.orgId,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                selectType: 0,
                driverNum: this.driverNum
            };
            this.$store.dispatch('DriverAnalysis/GET_SELECTDRIVERUSRRATEPAGE', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        downCar() {
            if (this.type == 'one') {
                if (domainName) {
                    if (domainName.split(':')[0] !== 'localhost') {
                        let url = `https://${domainName}/v1/getExportExcel/useDate/uploadDriverUseRatePage?orgId=${this.orgId}&selectType=${0}&driverNum=${this.bindDriver}`
                        location.href = url
                    } else {
                        let host = 'localhost:8080'
                        let url = `https://${host}/v1/getExportExcel/useDate/uploadDriverUseRatePage?orgId=${this.orgId}&selectType=${0}&driverNum=${this.bindDriver}`
                        location.href = url
                    }
                }
            } else {
                if (domainName) {
                    if (domainName.split(':')[0] !== 'localhost') {
                        let url = `https://${domainName}/v1/getExportExcel/useDate/uploadDriverUseRatePage?orgId=${this.orgId}&selectType=${0}`
                        location.href = url
                    } else {
                        let host = 'localhost:8080'
                        let url = `https://${host}/v1/getExportExcel/useDate/uploadDriverUseRatePage?orgId=${this.orgId}&selectType=${0}`
                        location.href = url
                    }
                }
            }

        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            console.log(item)
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            if (this.type == 'one') {
                this.columns = this.columnsOne
                this.getOneMonthOrderList()
            } else {
                this.columns = this.columnsAll
                this.getMonthOrderList()
            }
        },
    }
}
